import { render, staticRenderFns } from "./SubscriptionPurchaseLayout1.vue?vue&type=template&id=229de928&"
import script from "./SubscriptionPurchaseLayout1.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPurchaseLayout1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports